
import React, { useState } from 'react';
import styled from 'styled-components';
import NPCGenerator from './NPCGenerator';
import GlobalStyles from './GlobalStyles';
import logo from './assets/Logo1.webp';

const primaryColor = '#EAE8E3'; // Off-white for text
const backgroundColor = '#282c34'; // Dark grey to black for the background
const accentColor = '#C0A383'; // Metallic color for accents
const secondaryAccent = '#A67C52'; // Warm brown for secondary accents

const AppContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  background-color: ${backgroundColor};
  border-radius: 8px;
  color: ${primaryColor};
`;

const Title = styled.h1`
  color: ${accentColor};
  text-align: center;
`;

const Label = styled.label`
  margin: 10px;
  display: block;
  color: ${primaryColor};
`;

const Select = styled.select`
  width: 100%;
  padding: 8px;
  margin-top: 5px;
  border-radius: 4px;
  border: 1px solid ${secondaryAccent};
  color: #FFFFFF;
  background-color: #333740;
`;

const Logo = styled.img`
  display: block;
  max-width: 200px;  // Or whatever size fits your design
  margin: 0 auto 20px;  // Centers the logo and adds space below
`;

function App() {
    const [race, setRace] = useState('Human');
    const [charClass, setCharClass] = useState('Warrior');
    const [sex, setSex] = useState('Female');
    const [age, setAge] = useState('Young');

    const races = [
        "Human", "Elf", "Dwarf", "Halfling", "Gnome", "Orc",
        "Tiefling", "Dragonborn", "Half-Elf", "Half-Orc", "Goliath",
        "Aarakocra", "Genasi", "Tabaxi", "Firbolg"
    ];

    const classes = [
        "Barbarian", "Bard", "Cleric", "Druid",
        "Fighter", "Monk", "Paladin", "Ranger",
        "Rogue", "Sorcerer", "Warlock", "Wizard",
        "Artificer", "Blood Hunter"
    ];

    const sexes = ["Male", "Female", "Other"];
    const ages = ["Young Adult", "Middle-aged", "Old"];

    return (
      <>
        <GlobalStyles />
        <AppContainer>
            <Logo src={logo} alt="Logo" />
            <Title>D&D NPC Generator</Title>
            <Label>
                Race:
                <Select value={race} onChange={e => setRace(e.target.value)}>
                    {races.map(r => (
                        <option key={r} value={r}>{r}</option>
                    ))}
                </Select>
            </Label>
            <Label>
                Class:
                <Select value={charClass} onChange={e => setCharClass(e.target.value)}>
                    {classes.map(c => (
                        <option key={c} value={c}>{c}</option>
                    ))}
                </Select>
            </Label>
            <Label>
                Sex:
                <Select value={sex} onChange={e => setSex(e.target.value)}>
                    {sexes.map(s => (
                        <option key={s} value={s}>{s}</option>
                    ))}
                </Select>
            </Label>
            <Label>
                Age:
                <Select value={age} onChange={e => setAge(e.target.value)}>
                    {ages.map(a => (
                        <option key={a} value={a}>{a}</option>
                    ))}
                </Select>
            </Label>
            <NPCGenerator race={race} charClass={charClass} sex={sex} age={age} />
        </AppContainer>
    </>
  );
}

export default App;






